import styled from 'styled-components'

export default styled.span`
  color: #333333;
  display: block;
  font-size: 10px;
  letter-spacing: .08px;
  line-height: 18px;
`
